// ChatSocketContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { useSocket } from "./SocketProvider";

const ChatContext = createContext();

export const useChat = () => useContext(ChatContext);

const ChatProvider = ({ children }) => {
  const socket = useSocket();
  const [messages, setMessages] = useState([]);
  const [typingUser, setTypingUser] = useState(null);

  useEffect(() => {
    if (!socket) return;

    socket.on("receive-message", (msg) => {
      setMessages((prev) => [...prev, msg]);
    });

    socket.on("user-all-messages", (msgs) => {
      setMessages(msgs);
    });

    socket.on("typing", ({ user }) => {
      setTypingUser(user);
    });

    socket.on("file-received", (fileData) => {
      setMessages((prev) => [...prev, { ...fileData, type: "file" }]);
    });

    socket.on("incoming-call", ({ senderId }) => {
      alert(`Incoming call from ${senderId}`);
    });

    socket.on("call-accepted", ({ userId }) => {
      console.log(`Call accepted by ${userId}`);
    });

    return () => {
      socket.off("receive-message");
      socket.off("user-all-messages");
      socket.off("typing");
      socket.off("file-received");
      socket.off("incoming-call");
      socket.off("call-accepted");
    };
  }, [socket]);

  return (
    <ChatContext.Provider value={{ messages, typingUser }}>
      {children}
    </ChatContext.Provider>
  );
};

export default ChatProvider;